import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { OidcUserStatus, useOidcUser } from '@axa-fr/react-oidc';
import Layout from '../Layout/Layout';
import AuthenticatingError from './AuthenticatingError';
import Validating from './Validating';
import Loading from './Loading';

export default function AuthenticationSuccessCallBack() {
  const { oidcUserLoadingState } = useOidcUser();
  switch (oidcUserLoadingState) {
    case OidcUserStatus.Loading:
      return <Loading />;
    case OidcUserStatus.Unauthenticated:
      return <Validating />;
    case OidcUserStatus.LoadingError:
      return <AuthenticatingError />;
    default:
      return (
        <Layout plain>
          <h4 className="mt-5">
            <FontAwesomeIcon icon={faCheckCircle} className="text-success" />{' '}
            Authentication Successful
          </h4>
          <p className="lead">
            You will be redirected to the dashboard. Please wait a moment...
          </p>
          <p className="mt-5 small text-muted">
            If you feel this process is taking some time,{' '}
            <a href="/admin/">click here</a> to refresh the validation.
          </p>
        </Layout>
      );
  }
}
